import React, { useState } from "react";
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBBtn,
} from "mdbreact";
import { catalogCheckoutSession } from "api/stripe/checkoutSession";

const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Shown to GUESTS when they try to Save/Download from the pricing
// catalog. Members never see this (see SaveOptionList guest check).
// Collects an email and opens Stripe Checkout for the one-time $19
// registration; on success the buyer receives the license email and
// becomes a member whose prices are unmasked.
export const RegisterCatalogModal = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async () => {
    const normalized = (email || "").trim().toLowerCase();
    if (!EMAIL_REGEX.test(normalized)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await catalogCheckoutSession({ email: normalized });
      if (res?.url) {
        window.location.href = res.url;
        return;
      }
      setError("Could not start registration. Please try again.");
    } catch (e) {
      setError(
        e?.err || e?.status || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDBModal isOpen={open} toggle={onClose} centered>
      <MDBModalHeader toggle={onClose}>
        Unlock full pricing &amp; downloads
      </MDBModalHeader>
      <MDBModalBody>
        <p className="mb-3">
          Browsing is free. To <strong>save or download</strong> the full
          pricing catalog — including detailed unit costs and the complete
          supply-chain breakdown — register for a one-time{" "}
          <strong>$19</strong>.
        </p>
        <ul className="mb-3" style={{ paddingLeft: "1.1rem" }}>
          <li>Unhidden prices at every level</li>
          <li>Excel &amp; CSV export</li>
          <li>Full source references and price history</li>
        </ul>
        <label htmlFor="catalog-reg-email" className="form-label">
          Email
        </label>
        <input
          id="catalog-reg-email"
          type="email"
          className="form-control"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleRegister();
          }}
          disabled={loading}
        />
        {error ? (
          <div className="text-danger mt-2" style={{ fontSize: "0.85rem" }}>
            {error}
          </div>
        ) : null}
        <p className="mt-3 mb-0" style={{ fontSize: "0.8rem", color: "#6c757d" }}>
          Already a member?{" "}
          <a href="/authorization">Log in</a> — members download with no charge.
        </p>
      </MDBModalBody>
      <MDBModalFooter>
        <MDBBtn color="secondary" outline onClick={onClose} disabled={loading}>
          Cancel
        </MDBBtn>
        <MDBBtn color="primary" onClick={handleRegister} disabled={loading}>
          {loading ? "Redirecting…" : "Register for $19"}
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  );
};

export default RegisterCatalogModal;
